import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-training-waiting-list-modal',
  standalone: false,
  templateUrl: './training-waiting-list-modal.component.html',
  styleUrl: './training-waiting-list-modal.component.scss',
})
export class TrainingWaitingListModalComponent {
  @Input() showModal = false;
  @Output() showModalChange = new EventEmitter<boolean>();

  @Output() onCancel = new EventEmitter();
  @Output() onSend = new EventEmitter();

  send() {
    this.onSend.emit();
    this.close();
  }

  cancel() {
    this.onCancel.emit();
    this.close();
  }

  private close() {
    this.showModal = false;
    this.showModalChange.emit(this.showModal);
  }
}
